import NotAllowed from "../../../../../components/error/not-allowed";
import { Permission } from "../../../../permission";
import { PERMISSIONS } from "../../../../role-control/constants";
import AbsenceLetterDetail from "../../absence-letter/pages/absence-letter/absence-letter-detail";
import { NoSalaryCreate, NoSalaryEdit, NoSalaryList } from "../../absence-letter/pages/no-salary";

export const noSalaryLeaveDADRoutes = {
  noSalaryLeaveDADPage: {
    isAdmin: false,
    title: "4. Nghỉ không lương",
    path: "/procedure/no-salary-leave-dad",
    parentId: "procedure",
    component: () => {
      return (
        <NoSalaryList />

        // <Permission record={{ [PERMISSIONS["NO_SALARY_LEAVE_DAD"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <NoSalaryList />
        // </Permission>
      );
    },
  },
  createNoSalaryLeaveDADPage: {
    isAdmin: false,
    path: "/procedure/no-salary-leave-dad/create",
    parentId: "procedure",
    component: NoSalaryCreate,
  },
  detailNoSalaryLeaveDADPage: {
    isAdmin: false,
    path: "/procedure/no-salary-leave-dad/:applicationForLeaveId",
    parentId: "procedure",
    component: AbsenceLetterDetail,
  },
  editNoSalaryLeaveDADPage: {
    isAdmin: false,
    path: "/procedure/no-salary-leave-dad/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: NoSalaryEdit,
  },
};
